module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAATCAYAAACORR0GAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADTSURBVHgBxZXhDYIwEEavpP91hLqBbOAKboAbdARHYQNGkA1kA+sGOEH9LjSmaWjApAcvKXDphce1BygC3vsjTg0Gn0viMHqllFOQGARPAUksu1Y4WEEJYzAanUgMynxTAcJKvUJ40Ml8jYQTlcHEQSrqSIhUJLV0VNFGpBU5PAlJkIpuNPV9Cbibu5zoUXiPfmy2R/uKUPbd57EL+XbunprmaTH6zNywkD+sFvFnnf7ovjX5LBqjWOo9+vD/6ExTvxuSgQupFV+Fnr8IyFjSYmnHL6GDa7M2/MziAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/payment/pay-card.png
// module id = CTc2
// module chunks = 3